var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ImageSelectCropper',{attrs:{"id-image":_vm.idImage,"context":"avatar","width":175,"height":175,"borderradius":100,"fontsize":12},on:{"changeImage":_vm.onChangeImage,"removeImage":_vm.onRemoveImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }